<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-container-padding-mobile backdrop-blur-sm md:p-container-padding-desktop"
  (click)="close.emit()"
>
  <div
    role="dialog"
    aria-modal="true"
    aria-labelledby="confirm-modal-message"
    class="glass-panel relative flex w-full max-w-sm flex-col items-center gap-bento-gap rounded-xl p-8 pt-12"
    (click)="$event.stopPropagation()"
  >
    <!-- Fechar -->
    <button
      type="button"
      aria-label="Fechar"
      class="active-press absolute right-3 top-3 flex h-10 w-10 items-center justify-center rounded-full text-on-surface-variant transition-colors duration-150 hover:bg-surface-variant hover:text-primary"
      (click)="close.emit()"
    >
      <span class="material-symbols-outlined">close</span>
    </button>

    <!-- Mensagem -->
    <p
      id="confirm-modal-message"
      class="text-center font-headline-md text-headline-md text-on-surface"
    >
      {{ message() }}
    </p>

    <!-- Ações -->
    <div class="flex w-full gap-4">
      <button
        type="button"
        class="active-press w-full rounded-full bg-secondary-container py-3 font-headline-md text-headline-md text-on-secondary-fixed shadow-[0_0_15px_var(--color-secondary-container)] transition-transform duration-150 hover:scale-95"
        (click)="confirm.emit()"
      >
        Sim
      </button>
      <button
        type="button"
        class="w-full rounded-full border-2 border-outline-variant bg-transparent py-3 font-body-lg text-body-lg text-on-surface-variant transition-colors duration-150 hover:bg-surface-variant hover:text-on-surface"
        (click)="cancel.emit()"
      >
        Não
      </button>
    </div>
  </div>
</div>
